import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { login } from "../Tools/helpers";
import { setCookie } from "../Tools/AuthenticatedComponent";

const Login = () => {
  const [user, setUser] = useState({
    email: "",
    password: "",
  });
  const { email, password } = user;

  const [message, setMessage] = useState({
    status: false,
    message: "",
    label: "",
  });

  const setState = (e) => {
    setUser({
      ...user,
      [e.target.name]: e.target.value,
    });
  };

  const navigate = useNavigate();

  const submitLogin = async (e) => {
    e.preventDefault();
    setMessage({
      status: true,
      message: "Iniciando...",
    });

    const sendUser = await login("login", user);
    if (sendUser.status === "success") {
      const user = JSON.stringify(sendUser.user);
      await localStorage.setItem("STORAGE_KEY_IUMV", sendUser.access_token);
      await localStorage.setItem("USER_IUMV", user);
      setMessage({
        status: false,
        message: "",
      });
      
      if(sendUser.user.abbreviation === "franchise_admin"){
        navigate("/Summary");
        return;
      }
      navigate("/Home");
      return;
    }
    setMessage({
      status: true,
      message: "Credenciales incorrectas",
    });
  };

  const logout = async () => {
    await localStorage.removeItem("STORAGE_KEY_IUMV");
    await localStorage.removeItem("USER_IUMV");
  };

  useEffect(() => {
    logout();
  }, []);

  
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const inputStyle = {
    width: '100%',
    padding: '10px 14px',
    border: '1px solid #d1d5db',
    borderRadius: '7px',
    fontSize: '0.88rem',
    color: '#111827',
    outline: 'none',
    backgroundColor: '#fff',
    transition: 'border-color 0.15s, box-shadow 0.15s',
    marginTop: '6px',
  };

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#0f172a',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '24px',
      position: 'relative',
      overflow: 'hidden',
    }}>
      {/* Background decorative circles */}
      <div style={{ position: 'absolute', top: '-80px', right: '-80px', width: '320px', height: '320px', borderRadius: '50%', backgroundColor: 'rgba(220,38,38,0.08)', pointerEvents: 'none' }} />
      <div style={{ position: 'absolute', bottom: '-60px', left: '-60px', width: '240px', height: '240px', borderRadius: '50%', backgroundColor: 'rgba(220,38,38,0.05)', pointerEvents: 'none' }} />

      <div style={{
        width: '100%',
        maxWidth: '400px',
        backgroundColor: '#1e293b',
        borderRadius: '14px',
        boxShadow: '0 25px 60px rgba(0,0,0,0.5)',
        border: '1px solid #334155',
        overflow: 'hidden',
      }}>
        {/* Top accent bar */}
        <div style={{ height: '4px', backgroundColor: '#dc2626' }} />

        <div style={{ padding: '36px 32px 32px' }}>
          {/* Logo + title */}
          <div style={{ textAlign: 'center', marginBottom: '28px' }}>
            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '16px' }}>
              <div style={{ backgroundColor: '#fff', borderRadius: '10px', padding: '8px 14px', display: 'inline-block' }}>
                <img src="logo_iumv.png" alt="IUMV" style={{ height: '36px', display: 'block' }} onError={e => { e.target.style.display = 'none'; }} />
              </div>
            </div>
            <h1 style={{ fontSize: '1.15rem', fontWeight: 700, color: '#f1f5f9', margin: 0, marginBottom: '4px' }}>
              Portal Académico
            </h1>
            <p style={{ fontSize: '0.78rem', color: '#94a3b8', margin: 0 }}>Ingresa tus credenciales para continuar</p>
          </div>

          <form onSubmit={submitLogin}>
            {/* Email */}
            <div style={{ marginBottom: '16px' }}>
              <label htmlFor="email" style={{ display: 'block', fontSize: '0.75rem', fontWeight: 600, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '4px' }}>
                Correo electrónico
              </label>
              <div style={{ position: 'relative' }}>
                <i className="fa-solid fa-envelope" style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', fontSize: '13px', color: '#64748b', pointerEvents: 'none' }} />
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={email}
                  onChange={setState}
                  style={{ ...inputStyle, paddingLeft: '36px', backgroundColor: '#0f172a', color: '#f1f5f9', borderColor: '#334155' }}
                  onFocus={e => { e.target.style.borderColor = '#dc2626'; e.target.style.boxShadow = '0 0 0 2px rgba(220,38,38,0.15)'; }}
                  onBlur={e => { e.target.style.borderColor = '#334155'; e.target.style.boxShadow = 'none'; }}
                  placeholder="correo@ejemplo.com"
                  autoComplete="email"
                />
              </div>
            </div>

            {/* Password */}
            <div style={{ marginBottom: '24px' }}>
              <label htmlFor="password" style={{ display: 'block', fontSize: '0.75rem', fontWeight: 600, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '4px' }}>
                Contraseña
              </label>
              <div style={{ position: 'relative' }}>
                <i className="fa-solid fa-lock" style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', fontSize: '13px', color: '#64748b', pointerEvents: 'none' }} />
                <input
                  type={showPassword ? 'text' : 'password'}
                  id="password"
                  name="password"
                  value={password}
                  onChange={setState}
                  style={{ ...inputStyle, paddingLeft: '36px', paddingRight: '40px', backgroundColor: '#0f172a', color: '#f1f5f9', borderColor: '#334155' }}
                  onFocus={e => { e.target.style.borderColor = '#dc2626'; e.target.style.boxShadow = '0 0 0 2px rgba(220,38,38,0.15)'; }}
                  onBlur={e => { e.target.style.borderColor = '#334155'; e.target.style.boxShadow = 'none'; }}
                  placeholder="••••••••"
                  autoComplete="current-password"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(p => !p)}
                  style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: '#64748b', padding: '4px' }}
                >
                  <i className={`fa-solid ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`} style={{ fontSize: '13px' }} />
                </button>
              </div>
            </div>

            {/* Error message */}
            {message.status && (
              <div style={{ display: 'flex', alignItems: 'center', gap: '7px', backgroundColor: 'rgba(220,38,38,0.1)', border: '1px solid rgba(220,38,38,0.3)', borderRadius: '7px', padding: '9px 12px', marginBottom: '16px' }}>
                <i className="fa-solid fa-circle-exclamation" style={{ fontSize: '13px', color: '#dc2626', flexShrink: 0 }} />
                <span style={{ fontSize: '0.8rem', color: '#fca5a5' }}>{message.message}</span>
              </div>
            )}

            {/* Forgot password */}
            <div style={{ textAlign: 'right', marginBottom: '16px', marginTop: '-12px' }}>
              <button
                type="button"
                onClick={() => navigate('/ForgotPassword')}
                style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '0.75rem', color: '#64748b', transition: 'color 0.15s', padding: 0 }}
                onMouseEnter={e => e.currentTarget.style.color = '#dc2626'}
                onMouseLeave={e => e.currentTarget.style.color = '#64748b'}
              >
                ¿Olvidaste tu contraseña?
              </button>
            </div>

            {/* Submit */}
            <button
              type="submit"
              style={{
                width: '100%',
                padding: '11px',
                borderRadius: '7px',
                border: 'none',
                backgroundColor: '#dc2626',
                color: '#fff',
                fontSize: '0.85rem',
                fontWeight: 700,
                textTransform: 'uppercase',
                letterSpacing: '0.06em',
                cursor: 'pointer',
                transition: 'background-color 0.15s',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
              }}
              onMouseEnter={e => e.currentTarget.style.backgroundColor = '#b91c1c'}
              onMouseLeave={e => e.currentTarget.style.backgroundColor = '#dc2626'}
            >
              <i className="fa-solid fa-right-to-bracket" style={{ fontSize: '13px' }} />
              Iniciar sesión
            </button>
          </form>

          {/* Footer */}
          <p style={{ textAlign: 'center', fontSize: '0.72rem', color: '#475569', marginTop: '24px', marginBottom: 0 }}>
            IUMV — Sistema de Gestión Académica
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
